"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const InformationDialog_1 = require("../dialog/InformationDialog");
const GameCard_1 = require("./GameCard");
const RelatedGamesDialog = ({ title, relatedGames, selectGame, openDialog, handleClose }) => {
    const gameSelected = (game) => {
        selectGame(game);
        handleClose();
    };
    return ((0, jsx_runtime_1.jsx)(InformationDialog_1.default, Object.assign({ title: title, open: openDialog, onClose: handleClose }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, spacing: 2 }, { children: relatedGames &&
                relatedGames.map(game => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, sm: 6, md: 6, lg: 4 }, { children: (0, jsx_runtime_1.jsx)(GameCard_1.default, { game: game, onPress: gameSelected.bind(this, game) }) }), game.id))) })) })));
};
exports.default = RelatedGamesDialog;
//# sourceMappingURL=RelatedGamesDialog.js.map